export const EMPTY_LIST = Object.freeze([]);
export const EMPTY_MAP = Object.freeze({});

export const createAccessSlice = () => ({
    data: null,
    loading: false,
    error: null,
    loaded: false,
});

// Bucketed per step, because each step's list is opened, edited and written on its own: one step's
// unwritten ticks must not travel with another step's save.
export const initialState = {
    access: createAccessSlice(),
    pending: EMPTY_MAP,
    query: EMPTY_MAP,
    directory: EMPTY_MAP,
    searching: EMPTY_MAP,
    saving: EMPTY_MAP,
};
